const ContactLinks = {
    init() {
        const contactTexts = [...document.querySelectorAll('.node-person__mobile-number', '.node-person__function', '.node-person__phone-number')];
        contactTexts.forEach((contactText, index) => {
            const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
            const detectURL = contactText.innerText.match(urlRegex);
            let resultPost = `${contactText.innerHTML}`;

            if (detectURL) {
                detectURL.forEach(url => {
                    resultPost = resultPost.replace(url, '<a href= "' + url + '" role="link" target="_blank" > ' + url.trim() + '</a>')
                });
            }

            contactText.innerHTML = resultPost;
        });
    }
}


export default ContactLinks;